module.exports = __webpack_public_path__ + "img/bread-account-center-scenarios.290bb9b5.png";